import { render, staticRenderFns } from "./Carteira.vue?vue&type=template&id=02a0a799&"
import script from "./Carteira.vue?vue&type=script&lang=js&"
export * from "./Carteira.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports